<template>
  <!-- 抽屉详情 -->
  <el-dialog
    v-dragDialog
    :title="drawerTitle"
    :visible.sync="drawerVisible"
    width="1000px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      label-width="120px"
      :rules="formRules"
    >
      <el-row :gutter="15">
        <el-col :span="12">
          <shortOrderInfo ref="shortOrderInfo" :order="order" />
        </el-col>
        <el-col :span="12">
          <el-card shadow="never">
            <div slot="header">
              <span>取消订单</span>
            </div>
            <el-form-item
              v-if="order.Worker && order.Worker.Key"
              label="上门人员："
              prop="Worker.Name"
            >
              {{ order.Worker.Name }}@{{ order.Worker.Mobile }}
            </el-form-item>
            <el-form-item label="补偿费用：" prop="amount">
              <el-input-number
                :precision="2"
                v-model="dataForm.amount"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              v-if="order.Worker && order.Worker.Key"
              label="结算佣金："
              prop="commission"
            >
              <el-input-number
                :precision="2"
                v-model="dataForm.commission"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="取消原因：" prop="reason">
              <el-input
                type="textarea"
                rows="5"
                v-model="dataForm.reason"
              ></el-input>
            </el-form-item>
          </el-card>
        </el-col>
      </el-row>
      <el-form-item style="margin-top: 20px; text-align: right">
        <el-button type="success" @click="handleSubmit()">确认取消</el-button>
        <el-button type="info" @click="handleClose()">放弃取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
      <script>
import { shopCancelBook } from "@/api/bussiness/dzopen";
import workerSelector from "@/components/workerSelector.vue";
import memberSelector from "@/components/memberSelector.vue";
import enumSelector2 from "@/components/enumSelector2.vue";
import shortOrderInfo from "./shortOrderInfo.vue";

export default {
  components: {
    enumSelector2,
    workerSelector,
    memberSelector,
    shortOrderInfo,
  },
  data() {
    return {
      order: "",
      dataForm: {
        key: "",
        reason: "",
        amount: 0,
        commission: 0,
      },
      formRules: {
        reason: [
          { required: true, message: "请输入取消原因", trigger: "change" },
        ],
      },
      drawerTitle: "",
      drawerVisible: false,
    };
  },
  methods: {
    show(row) {
      this.drawerTitle = "取消订单";
      this.drawerVisible = true;
      this.order = row;
      this.dataForm = {
        key: row.Key,
        reason: "",
        amount: 0,
        commission: row.WorkerCommission,
      };
    },
    handleClose() {
      this.drawerVisible = false;
    },
    handleSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        shopCancelBook(this.dataForm).then((response) => {
          if (response) {
            this.drawerVisible = false;
            this.msg.successMsg("操作完成！");
            this.$emit("update");
          }
        });
      });
    },
  },
  mounted() {},
};
</script>
      <style lang='scss'  scoped>
/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  height: 1px;
}

/deep/.el-form-item {
  margin-bottom: 10px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}

.row-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: center;
}

/deep/.el-drawer__header {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #ff862f;
}

/deep/.el-drawer__body {
  overflow-y: scroll;
}

/deep/.el-card__header {
  font-size: 16px;
}
</style>